"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyDetailsDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const response_utils_1 = require("../../../../../../../libs/service-lib/src/lib/utils/response.utils");
const common_1 = require("@nestjs/common");
class CompanyDetailsDto {
}
exports.CompanyDetailsDto = CompanyDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Company history",
        example: "Tech Solutions Inc. was founded in 2020 to provide innovative tech solutions.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Company history must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Company history must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "companyHistory", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Major products",
        example: "Cloud services, AI solutions, and IoT devices.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Major products must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Major products must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "majorProducts", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Key customers",
        example: "Fortune 500 companies, startups, and government agencies.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Key customers must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Key customers must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "keyCustomers", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Business processes",
        example: "Agile development, DevOps, and customer-centric design.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Business processes must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Business processes must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "businessProcesses", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Account strategy",
        example: "Focus on long-term partnerships and customer satisfaction.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Account strategy must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Account strategy must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "accountStrategy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Targeting reason",
        example: "Targeting high-growth industries and emerging markets.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Targeting reason must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Targeting reason must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "targetingReason", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Competitors",
        example: "Competitor A, Competitor B, Competitor C.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Competitors must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Competitors must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "competitor", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Weakness",
        example: "Limited presence in Asia-Pacific region.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Weakness must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Weakness must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "weakness", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Action plan",
        example: "Expand operations in Asia-Pacific and hire local talent.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Action plan must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Action plan must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "actionPlan", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Potential opportunity",
        example: "Growing demand for AI and IoT solutions.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Potential opportunity must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Potential opportunity must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "potentialOpportunity", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Industry intelligence",
        example: "The tech industry is expected to grow by 10% annually.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Industry intelligence must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Industry intelligence must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "industryIntelligence", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Service plan",
        example: "Provide 24/7 customer support and regular updates.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Service plan must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Service plan must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "servicePlan", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Acquisition history",
        example: "Acquired Startup X in 2021 to enhance AI capabilities.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Acquisition history must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Acquisition history must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value; // Return the original value with tags to store in the database
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "acquisitionHistory", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Business profile",
        example: "Tech Solutions is a leader in cloud and AI solutions.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Business profile must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Business profile must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "bizProfile", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Service performance",
        example: "Consistently rated 4.8/5 by customers.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Service performance must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Service performance must not exceed 1000 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "servicePerformance", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Sales Pitch must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        value = value ? value.trim() : value;
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "salesPitch", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CompanyDetailsDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CompanyDetailsDto.prototype, "updatedBy", void 0);
